/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Agensi_CostInputs */

const en_mk_sol_agensi_cost = /** @type {(inputs: Mk_Sol_Agensi_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twelve seats on the Team plan: Rp 1,188,000 a month. At roughly 400 agent tasks a month, the AI cost still sits inside the plan quota.`)
};

const id_mk_sol_agensi_cost = /** @type {(inputs: Mk_Sol_Agensi_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dua belas kursi paket Tim: Rp 1.188.000 per bulan. Dengan kira-kira 400 tugas agen sebulan, biaya AI-nya masih di dalam kuota paket.`)
};

/**
* | output |
* | --- |
* | "Twelve seats on the Team plan: Rp 1,188,000 a month. At roughly 400 agent tasks a month, the AI cost still sits inside the plan quota." |
*
* @param {Mk_Sol_Agensi_CostInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_agensi_cost = /** @type {((inputs?: Mk_Sol_Agensi_CostInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Agensi_CostInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_agensi_cost(inputs)
	return en_mk_sol_agensi_cost(inputs)
});